<div class="drw-container">
  <div class="drw-header">
    <span class="drw-title">Capture Authorization</span>
    <button (click)="close()" mat-icon-button [disabled]="isSubmitting">
      <mat-icon class="drw-close" viewBox="0 0 24 24" fill="none">close</mat-icon>
    </button>
  </div>

  <div class="drw-content">
    <div class="drw-sub-content">
      <span class="drw-title">Authorization Information</span>

      <div class="authorization-info">
        <p>Authorization ID: <span>{{ data.authorization.id }}</span></p>
        <p>Total Amount: <span>{{ data.authorization.total_amount | currency }}</span></p>
        <p>Remaining Amount: <span>{{ data.authorization.remainingAmount | currency }}</span></p>
      </div>
    </div>

    <div class="drw-sub-content">
      <span class="drw-title">Capture Information</span>

      <form [formGroup]="captureForm" class="capture-form">
        <!-- Transaction Amount -->
        <label for="amount">Transaction Amount</label>
        <mat-form-field appearance="fill" class="full-width">
          <span matPrefix>&nbsp;$</span>
          <input matInput formControlName="amount" id="amount" placeholder="Amount" type="text" mask="separator.2" [thousandSeparator]="','">
          @if (captureForm.get('amount')?.hasError('required')) {
            <mat-error>
              Transaction amount is required
            </mat-error>
          }
          @if (captureForm.get('amount')?.hasError('min')) {
            <mat-error>
              Amount must be at least $0.01
            </mat-error>
          }
          @if (captureForm.get('amount')?.hasError('max')) {
            <mat-error>
              Amount cannot exceed remaining authorization amount of {{ data.authorization.remainingAmount | currency }}
            </mat-error>
          }
          @if (captureForm.get('amount')?.hasError('pattern')) {
            <mat-error>
              Please enter a valid amount (up to 2 decimal places)
            </mat-error>
          }
        </mat-form-field>

        <!-- Memo -->
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Memo</mat-label>
          <textarea matInput formControlName="memo" placeholder="Optional memo" rows="3"></textarea>
        </mat-form-field>
      </form>
    </div>
  </div>

  <div class="drw-footer">
    <button class="dialog-submit" mat-flat-button color="accent" [disabled]="captureForm.invalid || isSubmitting"
      (click)="submit()">
      @if (isSubmitting) {
        <mat-spinner [diameter]="20" color="accent"></mat-spinner>
      }
      @if (!isSubmitting) {
        <span>Capture Authorization</span>
      }
    </button>
  </div>
</div>